import { InjectionToken } from '@angular/core';

// Minimal feature-gate check, provided from FeatureAccessClientService (mirrors FIELD_PERMISSION_CHECKER to avoid a source-level import of @zag/features/ui).
export interface FeatureChecker {
  readonly featuresLoaded?: () => boolean;
  hasFeature(feature: string): boolean;
}

export const FEATURE_CHECKER = new InjectionToken<FeatureChecker>('FEATURE_CHECKER');
